import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { BaseResponse, FilterRequest, ListCreatedUser, PagedResponse, Response } from '@core/api';
import { WorkingHour, WorkingHourInsertRequest, WorkingHourUpdateRequest } from './customer-experience-working-hours.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CustomerExperienceWorkingHoursService {
    constructor(private http: HttpClient) {
    }

    get(request: string) {
        const headers = new HttpHeaders({ 'content-type': 'application/json' });
        return this.http.post<Response<WorkingHour>>(environment.apiUrl + '/api/CxWorkingHour/Get', JSON.stringify(request), { headers });
    }

    insert(request: WorkingHourInsertRequest) {
        return this.http.post<Response<WorkingHour>>(environment.apiUrl + '/api/CxWorkingHour/Insert', request);
    }

    updateActiveStatus(request: { workingHourId: string, activeFlag: boolean }) {
        return this.http.post<Response<any>>(environment.apiUrl + '/api/CxWorkingHour/UpdateStatus', request);
    }

    delete(request: string) {
        const headers = new HttpHeaders({ 'content-type': 'application/json' });
        return this.http.post<BaseResponse>(environment.apiUrl + '/api/CxWorkingHour/Delete', JSON.stringify(request), { headers });
    }

    list() {
        return this.http.post<Response<WorkingHour[]>>(environment.apiUrl + '/api/CxWorkingHour/List', {});
    }

    update(request: WorkingHourUpdateRequest) {
        return this.http.post<Response<WorkingHour>>(environment.apiUrl + '/api/CxWorkingHour/Update', request);
    }

    search(request: any) {
        return this.http.post<PagedResponse<WorkingHour>>(environment.apiUrl + '/api/CxWorkingHour/Search', request);
    }

    listCreatedUsers(filter?: FilterRequest): Observable<Response<ListCreatedUser[]>> {
        return this.http.post<Response<ListCreatedUser[]>>(environment.apiUrl + '/api/CxWorkingHour/ListCreatedUsers', filter);
    }

}
